import { isString } from 'lodash';

export const getAuthImageUrl = (src: string) => {
  // 2024-04-16 s3 资源不需要使用token访问, 因为token权限太大了，有安全风险
  return src;
};

export const getEncodedAuthImageUrl = (url: string) => {
  if (isString(url)) {
    const [path] = url.split('?');
    // eslint-disable-next-line no-useless-escape
    const filename = path.replace(/^.*[\\\/]/, '');
    return getAuthImageUrl(url.replace(filename, encodeURIComponent(filename)));
  }
  return url;
};
